<h1>E-Mail Validierung</h1>
<div class="row">
  @if (this.state == 'validating') {
    <div class="col-12"><p>Bitte warten, deine E-Mail-Adresse wird validiert...</p></div>
  }
  @if (this.state == 'success' || this.state == 'succeeded') {
    <div class="col-12"><p>Deine E-Mail-Adresse wurde erfolgreich validiert!</p></div>
  }
  @if (this.state == 'fail') {
    <div class="col-12"><p>Deine E-Mail-Adresse konnte nicht validiert werden!</p></div>
  }
</div>
